angular.module('impactx.imagezoom').controller('ImageZoomCtrl', [
    '$scope',
    '$element',
    ImageZoomController
]);

function ImageZoomController($scope, $element) {
    var self = this;
    const DEFAULT_ZOOM_FACTOR = 2;
    var width = 0;
    var height = 0;

    var zoomFactor;
    var rect = {};

    var lensPositionX = -1;
    var lensPositionY = -1;
    var lensWidth = 0;
    var lensHeight = 0;
    var zoomedImage;

    $element.on('mouseover', activateZoom);
    $element.on('mousemove', updateZoom);
    $element.on('mouseleave', deactivateZoom);
    self.zoomActive = false;

    function activateZoom() {
        zoomFactor = self.zoomFactor || DEFAULT_ZOOM_FACTOR;
        width = $element.outerWidth();
        height = $element.outerHeight();

        rect = $element[0].getBoundingClientRect();

        lensWidth = lensHeight = width / zoomFactor;

        zoomedImage = angular.element('.zoomed-image');
        zoomedImage.css('width', zoomFactor * width + 'px');
        zoomedImage.css('height', zoomFactor * height + 'px');
    }

    function updateZoom(event) {
        $scope.$applyAsync(function () {
            self.zoomActive = true;
            setLensPosition(event);
        });
    }

    function deactivateZoom() {
        $scope.$applyAsync(function () {
            self.zoomActive = false;
        });
    }

    function setLensPosition(event) {
        event.preventDefault();

        var elementOffset = $element.offset();
        lensPositionX = (event.pageX - elementOffset.left) - lensWidth / zoomFactor;
        lensPositionX = lensPositionX < 0 ? 0 : lensPositionX;
        lensPositionX = lensPositionX + lensWidth > width ? width - lensWidth : lensPositionX;
        lensPositionY = (event.pageY - elementOffset.top) - lensHeight / zoomFactor;
        lensPositionY = lensPositionY < 0 ? 0 : lensPositionY;
        lensPositionY = lensPositionY + lensHeight > height ? height - lensHeight : lensPositionY;

        var lens = angular.element('.image-zoom-lens');
        lens.css('left', lensPositionX + 'px');
        lens.css('top', lensPositionY + 'px');
        lens.css('height', lensHeight + 'px');
        lens.css('width', lensWidth + 'px');

        var posX = (zoomedImage[0].offsetWidth - width + lensWidth * zoomFactor) * (lensPositionX / width);
        var posY = (zoomedImage[0].offsetHeight - height + lensHeight * zoomFactor) * (lensPositionY / height);
        zoomedImage[0].style.transform = 'translate3d(' + posX * -1 + 'px,' + posY * -1 + 'px,0)';
    }
}